import { render, staticRenderFns } from "./cvpageA.vue?vue&type=template&id=be9448e6&scoped=true&"
import script from "./cvpageA.vue?vue&type=script&lang=js&"
export * from "./cvpageA.vue?vue&type=script&lang=js&"
import style0 from "./cvpageA.vue?vue&type=style&index=0&id=be9448e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9448e6",
  null
  
)

export default component.exports